module.exports = __webpack_public_path__ + "static/media/right_decor.248d5ac0.svg";